// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/tabs/index.css
// module id = 454
// module chunks = 32